export default "__VITE_ASSET__Ct5ku4ay__"